// extracted by mini-css-extract-plugin
module.exports = {"coursesListWrapper":"CoursesList_coursesListWrapper__xeewE","noCourse":"CoursesList_noCourse__Vex3x"};